import { useEffect, useState } from "react";
import "./App.css";
import { Box, IconButton, Modal, Typography } from "@mui/material";
import { Item } from "./components/Item/Item";
import {
  DocumentData,
  collection,
  deleteDoc,
  doc,
  getDocs,
  updateDoc,
} from "firebase/firestore";
import { db } from "./firebase";
import { GroceryForm } from "./components/Item/GroceryForm";

function App() {
  const [groceries, setGroceries] = useState<DocumentData[]>([]);
  useEffect(() => {
    // Fetch the groceries data from the Firebase collection
    const fetchData = async () => {
      const groceriesCollection = collection(db, "groceries");
      const groceriesSnapshot = await getDocs(groceriesCollection);
      const groceriesData = groceriesSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setGroceries(groceriesData);
    };
    fetchData();
  }, []);

  const [showForm, setShowForm] = useState(false);

  const handleToggleForm = () => {
    setShowForm(!showForm);
  };

  const decreaseQuantity = async (index: number) => {
    const grocery = groceries[index];
    const groceryRef = doc(db, "groceries", grocery.id);
    if (grocery.quantity === 0) {
      return;
    }
    await updateDoc(groceryRef, {
      quantity: grocery.quantity - 1,
    });
    setGroceries((prevGroceries) => {
      const newGroceries = [...prevGroceries];
      newGroceries[index] = {
        ...newGroceries[index],
        quantity: newGroceries[index].quantity - 1,
      };
      return newGroceries;
    });
  };

  const increaseQuantity = async (index: number) => {
    const grocery = groceries[index];
    const groceryRef = doc(db, "groceries", grocery.id);
    await updateDoc(groceryRef, {
      quantity: grocery.quantity + 1,
    });
    setGroceries((prevGroceries) => {
      const newGroceries = [...prevGroceries];
      newGroceries[index] = {
        ...newGroceries[index],
        quantity: newGroceries[index].quantity + 1,
      };
      return newGroceries;
    });
  };

  const handleResetItem = async (index: number) => {
    const grocery = groceries[index];
    const groceryRef = doc(db, "groceries", grocery.id);
    await updateDoc(groceryRef, {
      quantity: 0,
    });
    setGroceries((prevGroceries) => {
      const newGroceries = [...prevGroceries];
      newGroceries[index] = {
        ...newGroceries[index],
        quantity: 0,
      };
      return newGroceries;
    });
  };

  const handleRemoveItem = async (index: number) => {
    const grocery = groceries[index];
    const groceryRef = doc(db, "groceries", grocery.id);
    // Open confirmation modal here and wait for user input
    const confirmed = await openConfirmationModal();
    if (confirmed) {
      await deleteDoc(groceryRef);
      setGroceries((prevGroceries) => {
        const newGroceries = [...prevGroceries];
        newGroceries.splice(index, 1);
        return newGroceries;
      });
    }
  };

  console.log("querySnapshot", groceries);

  return (
    <Box sx={{}}>
      <header>
        <Box sx={{
          my: 4,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
        }} maxHeight={200}>
          <img height="100px" className="" alt="logo" src="logo.png" />
        </Box>
      </header>

      {/* {showForm && <GroceryForm />} */}

      <Modal open={showForm} onClose={handleToggleForm}>
        <GroceryForm handleToggleForm={handleToggleForm} />
      </Modal>

      {/* <p className="text-red-500">
          Edit <code>src/App.tsx</code> and save to reload.
        </p> */}

      <main>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            mb: 20,
          }}
        >
          <IconButton onClick={handleToggleForm}>
            <svg
              stroke="currentColor"
              fill="black"
              stroke-width="0"
              role="img"
              viewBox="0 0 24 24"
              height="1em"
              width="1em"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title></title>
              <path d="M18 13.496h-4.501v4.484h-3v-4.484H6v-2.99h4.5V6.021h3.001v4.485H18v2.99zM21 .041H3C1.348.043.008 1.379 0 3.031v17.94c.008 1.65 1.348 2.986 3 2.988h18c1.651-.002 2.991-1.338 3-2.988V3.031c-.009-1.652-1.348-2.987-3-2.99z"></path>
            </svg>
            <Typography mx={2} variant="h4" color="initial">
              Add new Item
            </Typography>
          </IconButton>
          <aside>
            <Typography mx={4}>
              Please maintain grocery list and update the quantity of the items.
              This will help to keep track of the items and avoid wastage. And
              also add new items to the list. We can also add the notes, icon
              and image of the item. The quantity of the item can be increased
              or decreased.
            </Typography>
          </aside>

          {groceries.map((item, index) => (
            <Item
              index={index}
              name={item.name}
              quantity={item.quantity}
              notes={item.notes}
              handleResetItem={handleResetItem}
              increaseQuantity={increaseQuantity}
              handleRemoveItem={handleRemoveItem}
              iconLabel={""}
              decreaseQuantity={decreaseQuantity}
              imageUrl={""} // notes={item.notes}
              // iconLabel={item.iconLabel}
              // imageUrl={item.imageUrl}
            />
          ))}
        </Box>
      </main>

      <footer>
        {/* <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: 100,
            px: 4,
            position: "fixed",
            bottom: 0,
            width: "100vw",
            backgroundColor: "black",
            color: "white",
          }}
        >
          <p>Please maintain social distancing and wear a mask to protect.</p>
        </Box> */}
      </footer>
    </Box>
  );
}

export default App;

function openConfirmationModal() {
  return new Promise<boolean | undefined>((resolve) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete the item?"
    );
    resolve(confirmed);
  });
}
